import Steps7 from './Steps7'
export default Steps7
